import React, { useContext, useState } from "react";
import { observer } from "mobx-react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { EventOffer } from "@gp/offer";
import { useRootAppStore } from "@hooks";
import { LiveEventSideMenuContext } from "@state/context/live/live-event-side-menu/LiveEventSideMenuContext";

export const ToggleIsEventInOfferButton = observer(
	function ToggleIsEventInOfferButton(props: {
		event: EventOffer;
		isEventActive: boolean;
	}) {
		const { t } = useTranslation();
		const eventMenuStore = useContext(LiveEventSideMenuContext);
		const rootStore = useRootAppStore();

		const [isHover, setIsHover] = useState(false);

		const btnClasses = classNames(
			"nav--multi__btn btn btn--square btn--square--xsml btn--primary--inverted"
		);

		const iconClasses = classNames("u-icon u-icon--animation-reset", {
			"u-icon--xtny u-icon--close": props.isEventActive && !isHover,
			"u-icon--xtny u-icon--close u-color--sent--danger":
				props.isEventActive && isHover,
			"u-icon--tny u-icon--add": !props.isEventActive && !isHover,
			"u-icon--tny u-icon--add u-color--sent--note":
				!props.isEventActive && isHover,
		});

		if (props.isEventActive) {
			return (
				<button
					type="button"
					className={btnClasses}
					title={t("LIVE.SIDEMENU.REMOVE_EVENT_FROM_VIEW")}
					onClick={() => {
						eventMenuStore.removeEvent(props.event.id);
						rootStore.myBetsViewStore.cashoutStore.disposeSubscription(
							props.event.id
						);
					}}
					onMouseEnter={() => setIsHover(true)}
					onMouseLeave={() => setIsHover(false)}
				>
					<i className={iconClasses} />
				</button>
			);
		}

		return (
			<button
				type="button"
				onClick={() => eventMenuStore.addEvent(props.event.id)}
				onMouseEnter={() => setIsHover(true)}
				onMouseLeave={() => setIsHover(false)}
				title={t("LIVE.SIDEMENU.ADD_EVENT_TO_VIEW")}
				className={btnClasses}
			>
				<i className={iconClasses} />
			</button>
		);
	}
);
